var _path, _path2, _ellipse, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.1447 14.9468V9C44.1447 7.34314 42.8015 6 41.1447 6H11C9.34315 6 8 7.34315 8 9V63.8382C8 65.4951 9.34315 66.8382 11 66.8382H26.0723",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6055 19.9491H64.5984C66.2553 19.9491 67.5984 21.2922 67.5984 22.9491V81C67.5984 82.6569 66.2553 84 64.5984 84H32.6055C30.9486 84 29.6055 82.6569 29.6055 81V22.9491C29.6055 21.2922 30.9486 19.9491 32.6055 19.9491Z",
    fill: "#FC9C9C"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.6017,
    cy: 70.2748,
    rx: 3.59393,
    ry: 3.55838,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5322 35.6057L56.6014 52.3504C56.3966 52.7086 56.2883 53.1146 56.2871 53.5282C56.286 53.9417 56.3921 54.3484 56.5948 54.7076C56.7976 55.0669 57.09 55.3663 57.4428 55.5761C57.7957 55.7858 58.1969 55.8985 58.6063 55.9031H78.4679C78.8774 55.8985 79.2785 55.7858 79.6314 55.5761C79.9843 55.3663 80.2766 55.0669 80.4794 54.7076C80.6822 54.3484 80.7882 53.9417 80.7871 53.5282C80.786 53.1146 80.6776 52.7086 80.4729 52.3504L70.542 35.6057C70.333 35.2576 70.0387 34.9699 69.6875 34.7702C69.3363 34.5705 68.9401 34.4656 68.5371 34.4656C68.1341 34.4656 67.7379 34.5705 67.3867 34.7702C67.0355 34.9699 66.7412 35.2576 66.5322 35.6057Z",
    fill: "white",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5371 42.2762V46.91",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5371 50.0117H68.5513",
    stroke: "#383434",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.6883cdc7fa20e582662daee46cf87eb0.svg";
export { ForwardRef as ReactComponent };